export const headItems = [
  'Car model',
  'Company class',
  'SIPP',
  'Car Category',
  'Refers to location',
]

export const NOT_AVAILABLE = 'N/A'
export const SHORT_NOT_AVAILABLE = 'NA'

export const VEHICLE_DETAILS_FORM_ID = 'vehicle-details-form'
